export const getTheme = () => localStorage.getItem("rj_theme") || "light";

export const setTheme = (t) => {
  localStorage.setItem("rj_theme", t);
  document.body.classList.toggle("theme-dark", t === "dark" && !document.body.classList.contains("admin-route"));
};

export const applyTheme = (pathname) => {
  const isAdmin = pathname.startsWith("/admin");
  document.body.classList.toggle("admin-route", isAdmin);
  document.body.classList.toggle("theme-dark", !isAdmin && getTheme() === "dark");
};
